import { render, staticRenderFns } from "./CatalogDetailAddCartArea.vue?vue&type=template&id=4d928ed8&scoped=true&"
import script from "./CatalogDetailAddCartArea.vue?vue&type=script&lang=ts&"
export * from "./CatalogDetailAddCartArea.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogDetailAddCartArea.vue?vue&type=style&index=0&id=4d928ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d928ed8",
  null
  
)

export default component.exports